import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IndexedDBStorageService {
  #dbPromise: Promise<IDBDatabase>;

  constructor() {
    this.#dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open('pinup-team', 1);
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains('flags')) {
          db.createObjectStore('flags', { keyPath: 'key' });
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  async getFlag(key: string): Promise<boolean> {
    const db = await this.#dbPromise;

    return new Promise((resolve, reject) => {
      const tx = db.transaction('flags', 'readonly');
      const store = tx.objectStore('flags');
      const request = store.get(key);
      request.onsuccess = () => resolve(request.result ? request.result.value : false);
      request.onerror = () => reject(request.error);
    });
  }

  async setFlag(key: string, value: boolean): Promise<void> {
    const db = await this.#dbPromise;

    return new Promise((resolve, reject) => {
      const tx = db.transaction('flags', 'readwrite');
      const store = tx.objectStore('flags');
      store.put({ key, value });
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  }
}
